import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { actionCreators as filterActionCreators } from "../../store/Filter"
import "./FilterChooser.scss"

export const FilterChooser = (props) => {
    const dispatch = useDispatch()
    const filter = useSelector(state => state.filter)
    
    const custom = props?.custom || null
    const mini = props?.mini
    const disabled = props?.disabled
    const datasetId = props?.datasetId
    const style = props?.style
    const showN = props?.showN || false
    const hiddenCategories = props?.hiddenCategories || null

    // Safely get selectedFilter with fallback
    const selectedFilter = datasetId 
        ? filter?.selected?.[datasetId] ?? null 
        : filter?.selectedFilter ?? null

    // Threshold for styling
    const threshold = 50
    const sampleSize = selectedFilter?.n ?? null
    const isBelowThreshold = sampleSize !== null && sampleSize < threshold

    // Optional: Dispatch refresh if sample size is missing but filter exists
    useEffect(() => {
        if (datasetId && selectedFilter && sampleSize === null) {
            dispatch(filterActionCreators.refreshSampleSizes(datasetId))
        }
    }, [dispatch, datasetId, selectedFilter, sampleSize])

    return (
        <div className={`filter-chooser${mini ? " mini" : ""}${disabled ? " disabled" : ""}`} style={style}>
            {/* Wave cell - commented out / hidden unless you need it */}
            {/* {false && ( // Change to true if you want to re-enable */}
            {/*     <div className={"wave-cell " + (disabled ? " disabled" : "")}> */}
            {/*         <i className="fal fa-calendar-alt glyph" /> */}
            {/*         <span className="label">Q1 2019–Q1 2020</span> */}
            {/*     </div> */}
            {/* )} */}

            <div 
                className={"filter-cell text-truncate " + (disabled ? " disabled" : "")}
                onClick={() => {
                    if (!disabled) {
                        window.topBar.openMenu("filter", { datasetId, custom, hiddenCategories })
                    }
                }}
                title={selectedFilter?.label ?? "No filter selected"}
            >
                <i className="fal fa-filter glyph" />
                <span className="label">
                    {selectedFilter 
                        ? (selectedFilter.autoLabel || selectedFilter.label || "Filter Not Set") 
                        : "Loading filter..."}
                </span>
            </div>

            {showN && (
                <div className={`sample-cell ${isBelowThreshold ? "low-sample" : ""}`}>
                    <i className="fal fa-male xglyph" />
                    <span className="label">
                        {sampleSize !== null ? sampleSize : "..."}
                    </span>
                </div>
            )}
        </div>
    )
}